// Mobile menu functionality
document.addEventListener('DOMContentLoaded', function() {
    // Get the mobile menu button and mobile menu elements
    const mobileMenuButton = document.getElementById('mobile-menu-button');
    const mobileMenu = document.getElementById('mobile-menu');
    
    // Add click event listener to the mobile menu button
    if (mobileMenuButton) {
        mobileMenuButton.addEventListener('click', function() {
            // Toggle the 'hidden' class on the mobile menu
            if (mobileMenu) {
                mobileMenu.classList.toggle('hidden');
                
                // Toggle icon between menu and close
                const icon = this.querySelector('i');
                if (icon) {
                    if (mobileMenu.classList.contains('hidden')) {
                        icon.className = 'ri-menu-line text-2xl';
                    } else {
                        icon.className = 'ri-close-line text-2xl';
                    }
                }
            }
        });
    }
    
    // Close mobile menu when window is resized to desktop size
    window.addEventListener('resize', function() {
        if (window.innerWidth >= 1024 && mobileMenu && !mobileMenu.classList.contains('hidden')) {
            mobileMenu.classList.add('hidden');
            
            // Reset icon to menu
            const icon = mobileMenuButton.querySelector('i');
            if (icon) {
                icon.className = 'ri-menu-line text-2xl';
            }
        }
    });
    
    // Set underline permanently for "Become a Client" link
    const underline = document.getElementById('become-client-underline');
    if (underline) {
        underline.style.width = '100%';
    }

    // Function to scroll to a section with header offset
    function scrollToSection(sectionId) {
        // For Ghost template, we need to redirect to the main site with the section hash
        window.location.href = 'https://www.karczewski.io/#' + sectionId;
        return false;
    }

    // Expose functions to the global scope if needed by inline onclicks
    window.scrollToSection = scrollToSection;
    window.toggleMobileMenu = function() {
        if (mobileMenu) {
            mobileMenu.classList.toggle('hidden');
            
            // Toggle icon between menu and close
            const icon = mobileMenuButton.querySelector('i');
            if (icon) {
                if (mobileMenu.classList.contains('hidden')) {
                    icon.className = 'ri-menu-line text-2xl';
                } else {
                    icon.className = 'ri-close-line text-2xl';
                }
            }
        }
    };
});
